import { Injectable } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AuthConfig, JwksValidationHandler, OAuthService } from 'angular-oauth2-oidc';
// AuthConfig from oauth2-oidc
import { environment } from 'src/environments/environment';
// import { filter } from 'rxjs/internal/operators/filter';

export interface Claims {
  [x: string]: any;
  mfa_enabled: boolean;
  user_name: string;
}
//
// Configuration of OIDC with Fortify.
//
const config = {
  discoveryDocumentUrl: `${environment.fortifyUrl}/.well-known/openid-configuration`,
  loginUrl: `${environment.fortifyUrl}/connect/authorize`,
  issuer: environment.fortifyUrl,
};
export const discoveryDocumentUrl = config.discoveryDocumentUrl;
export const loginUrl = config.loginUrl;
export const authConfigDirect: AuthConfig = {
  issuer: config.issuer,
  redirectUri: `${window.location.origin}/login/fortify-direct`,
  requestAccessToken: false,
  showDebugInformation: true,
  clientId: environment.fortifyClientId,
  strictDiscoveryDocumentValidation: true,
  postLogoutRedirectUri: `${window.location.origin}/login/login`,
  
};

@Injectable({
  providedIn: 'root'
})
export class FortifyOidcService {

  constructor(
    private oauthService : OAuthService 
  ) {

  }
  // ---------------------------------------------------------------------------
  // -----------------------   oauthService.events   ---------------------------
  // ---------------------------------------------------------------------------
  events() {
    this.oauthService.events
      .subscribe(data => {
        console.log(data);
        //
        // deal with different conditions.
        //
        if (data.type === 'token_received') {
          this.oauthService.logOut();
        }
      })
  }


  
  // ---------------------------------------------------------------------------
  // -----------------------   Configuration   ---------------------------------
  // ---------------------------------------------------------------------------
  
  configure() {
    this.oauthService.configure(authConfigDirect);
    this.oauthService.loadDiscoveryDocument().then( doc => {
      console.log(doc);
      this.oauthService.tryLoginImplicitFlow().then( value => {
        console.log(value);
        if (!value) { // keep trying until the ImplicitFlow comes back with a value.
            this.oauthService.initImplicitFlow();
        }
      })
	  });
  }





  getTokenAndLogOut() {
    //
    // configure and listen to events.
    //
    this.oauthService.configure(authConfigDirect);
    //
    // load and try Implicit Flow techniques.
    //
    this.oauthService.loadDiscoveryDocument().then( doc => {
      this.oauthService.tryLoginImplicitFlow().then( value => {
        console.log(value);
      })
      //
      // TODO:: Use these as testing grounds for future calls already connected.
      //
	  });





    
  }







// ---------------------------------------------------------------------------
// -----------------------   Status Helpers  ---------------------------------
// ---------------------------------------------------------------------------
  get accessToken(): string {
    return this.oauthService.getAccessToken();
  }
  get refreshToken() { 
    return this.oauthService.getRefreshToken(); 
  }
  get identityClaims() { 
    return this.oauthService.getIdentityClaims(); 
  }
  get idToken(): string {
    return this.oauthService.getIdToken();
  }
  get logoutUrl() { 
    return this.oauthService.logoutUrl; 
  }
  get userName(): string {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['full_name'];
  }

// ---------------------------------------------------------------------------
// -----------------------   Login Methods   ---------------------------------
// ---------------------------------------------------------------------------

  tryLogin() {
    this.oauthService.tryLogin({
      onTokenReceived: context => {
          //
          // Output just for purpose of demonstration
          // Don't try this at home ... ;-)
          //
          console.debug("logged in");
          console.debug(context);
      }
  });
  }
  login() {
    //
    // Try Different Logins.
    //
    // this.oauthService.initImplicitFlowInternal();
    this.oauthService.initLoginFlow();
    // this.oauthService.initCodeFlow();
  }
  logout() {
    this.oauthService.logOut();
  }
  refresh() {
    this.oauthService.refreshToken()
    .then(info => console.log('refresh ok', info))
    .catch(err => console.error('refresh error', err));;
  }
  hasValidToken() { 
    return this.oauthService.hasValidAccessToken(); 
  }
  silentRefresh() {
    this
    .oauthService
    .silentRefresh()
    .then(info => console.log('refresh ok', info))
    .catch(err => console.error('refresh error', err));
  }
  setupAutomaticSilentRefresh() {
    this.oauthService.setupAutomaticSilentRefresh();
  }



// ---------------------------------------------------------------------------
// -----------------------   Event Listener   --------------------------------
// ---------------------------------------------------------------------------
  eventChanges() { // Automatically load user profile.
    this.oauthService.events
      .subscribe( event => {
        switch ( event.type) {
          case 'discovery_document_loaded':
            console.log('%c discovery_document_loaded :', 'color: white; background: black;');
            console.log(event);
            break;
          case 'token_validation_error':
            console.log('%c token_validation_error :', 'color: pink; background: black;');
            console.log(event);
            this.silentRefresh();
            break;
          case 'token_received':
            console.log('%c token_received :', 'color: lightgreen; background: black;');
            console.log(event);
            console.log(this.idToken);
            let access = this.oauthService.getAccessToken();
            console.log(access);
            if ( access != null ){
              this.oauthService.loadUserProfile();
            }
            break;
          case 'silent_refresh_timeout':
            console.log('%c silent_refresh_timeout :', 'color: pink; background: black;');
            console.log(event);
            break;
          case 'token_expires':
            console.log('%c token_expires :', 'color: pink; background: black;');
            console.log(event);
            // this.refresh();
            this.silentRefresh();
            break;
          case 'token_error':
            console.log('%c token_error :', 'color: pink; background: black;');
            console.log(event);
            break;

          default:
            console.log('%c default case:', 'color: lightblue; background: black;');
            console.log(event);
            
            break;
        }

        //this.oauthService.loadUserProfile();
        
      });
  }



  
  

}
